export const tableProps = {
    noData: 'No existen registros',
    noResults: 'No se encontraron registros',
    rowsText: 'Resultados por página',
    rows: [50, 100, 200]
}